import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAccount } from "../../context/AccountContext";
import { usePlatform } from "../../hooks/usePlatform";

const EXAMPLES = [
  { key: "lastWeek", icon: "bi-calendar-week" },
  { key: "favorites", icon: "bi-star" },
  { key: "github", icon: "bi-github" },
  { key: "documentation", icon: "bi-book" },
  { key: "videos", icon: "bi-play" },
];

export const Empty = ({ onExampleClick }) => {
  const { t } = useTranslation();
  const { account } = useAccount();
  const { isMacOS } = usePlatform();
  const isPro = account?.plan === "pro";

  return (
    <div className="search-empty">
      <div className="text-center px-3 pt-4 pb-3">
        <div className="search-empty__icon mx-auto mb-3">
          <i className="bi bi-stars"></i>
        </div>
        <h4 className="h5 mb-1">
          {isPro
            ? t("search.modal.empty.askAnything.title", "Ask me anything")
            : t("search.modal.empty.explore.title")}
        </h4>
        <p className="text-secondary small mb-4">
          {isPro
            ? t(
                "search.modal.empty.askAnything.subtitle",
                "Use natural language to find your bookmarks"
              )
            : t("search.modal.empty.explore.subtitle")}
        </p>

        <div className="d-flex flex-wrap justify-content-center gap-2">
          {EXAMPLES.map(({ key, icon }) => {
            const label = t(`search.modal.empty.examples.${key}`);
            return (
              <button
                key={key}
                type="button"
                className="search-suggestion d-inline-flex align-items-center gap-2"
                onClick={() => onExampleClick(label)}
              >
                <i className={`bi ${icon} text-secondary`}></i>
                <span>{label}</span>
              </button>
            );
          })}
        </div>

        {!isPro && (
          <div className="mt-4">
            <Link
              className="btn btn-purple btn-sm fw-semibold"
              to="/settings/subscription?plan=pro"
            >
              <i className="bi bi-stars me-1 text-yellow" aria-hidden="true"></i>
              {t("search.modal.empty.upgrade")}
            </Link>
          </div>
        )}
      </div>

      {/* Footer hint bar — keyboard hints are a desktop affordance, so the
          whole bar stays hidden on small (touch) screens. */}
      <div className="search-empty__footer d-none d-md-flex align-items-center gap-3 px-3 py-2 small text-muted">
        {isPro && (
          <span className="d-flex align-items-center gap-1">
            <kbd>↵</kbd> {t("search.modal.hints.ask", "Ask")}
          </span>
        )}
        <span className="ms-auto d-flex align-items-center gap-1">
          <kbd>{isMacOS ? "⌘K" : "Ctrl+K"}</kbd>{" "}
          {t("search.modal.hints.open", "Open anywhere")}
        </span>
      </div>
    </div>
  );
};
